import React from 'react'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

const TableHead = (props) => {
    const canViewStoreName = checkStoreName()

    return (
        <thead className="ShippingCarrierRuleTableHead TableHead">
        <tr className="RuleHeadTable">
            <th className="Priority">Priority</th>
            <th className="Platform">Platform</th>
            <th className="Country">Country</th>
            <th className="State">State</th>
            {canViewStoreName && <th className="Store">Store</th>}
            <th className="SKU">SKU</th>
            <th className="Tag">Tag</th>
            <th className="Weight">Weight</th>
            <th className="ShippingCarrier">Shipping Carrier</th>
            <th className="OriginalCarrier">Original Carrier</th>
            <th className="Status">Status</th>
            <th className="Action">Action</th>
        </tr>
        </thead>
    )
}

export default TableHead
